import { apiFetch } from '../utils/apiFetch';  // Add at the top
// src/services/AuthService.js

export async function login(username, password) {
  try {
    const apiUrl = process.env.REACT_APP_API_URL;

    const response = await apiFetch(`${apiUrl}/token`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password }),
    });

    const data = await response.json();

    if (response.ok) {
      return { user: data.user };
    } else {
      throw new Error(data.detail || 'Login failed');
    }
  } catch (error) {
    console.error('Login service failed:', error);
    throw error;
  }
}

export async function logout() {
  const apiUrl = process.env.REACT_APP_API_URL;

  await apiFetch(`${apiUrl}/logout`, {
    method: 'POST',
  });
}

export async function getCurrentUser() {
  const apiUrl = process.env.REACT_APP_API_URL;

  const response = await apiFetch(`${apiUrl}/users/me`, {
    method: 'GET',
  });

  if (response.ok) {
    return await response.json();
  } else {
    throw new Error('Not authenticated');
  }
}

export function initializeGoogleSignIn(callback) {
  const waitForGoogle = setInterval(() => {
    if (window.google && window.google.accounts) {
      clearInterval(waitForGoogle);
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: async (response) => {
          const idToken = response.credential;

          // Exchange token with backend (which will set the cookie)
          const apiUrl = process.env.REACT_APP_API_URL;
          const res = await apiFetch(`${apiUrl}/token/google`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ token: idToken }),
          });

          if (res.ok) {
            const data = await res.json();
            callback(data.user); // ✅ Only return user to frontend
          } else {
            console.error('Google token exchange failed');
          }
        }
      });
    }
  }, 100);
}

export function renderGoogleButton() {
  const waitForGoogle = setInterval(() => {
    if (window.google && window.google.accounts) {
      clearInterval(waitForGoogle);
      window.google.accounts.id.renderButton(
        document.getElementById("google-signin-button"),
        { theme: "outline", size: "large" }
      );
    }
  }, 100);
}

export function googleSignOut() {
  if (window.google?.accounts?.id?.disableAutoSelect) {
    window.google.accounts.id.disableAutoSelect();  // Clears Google's auto sign-in session
  }
}